export enum ExtraItemEnum {
  All = 'All',
  Other = 'Other',
  AddBillingContact = 'Add new',
  AddWorker = 'Add new worker',
  AddCompany = 'Add new company',
}
